import {
  Stack,
  TextField,
  Select,
  MenuItem,
  Grid,
  Autocomplete,
} from "@mui/material"
import { useState } from "react"
import { searchFeeHeads } from "../../api"
import FormItem from "../ui/FormItem"
import Modal from "../ui/Modal"

const schedules = ["SEMESTER", "ANNUAL", "CUSTOM"]

// currency,
// amount,
// discount,
// reference,
// year,
// semester,

const scheduleMap = {
  SEMESTER: Array(8)
    .fill(0)
    .map((_, i) => ({
      currency: "INR",
      name: `Semester ${i + 1}`,
      semester: i + 1,
      amount: 0,
      discount: 0,
    })),
  ANNUAL: Array(4)
    .fill(0)
    .map((_, i) => ({
      currency: "INR",
      name: `Year ${i + 1}`,
      year: i + 1,
      amount: 0,
      discount: 0,
    })),
  CUSTOM: [
    {
      currency: "INR",
      name: "N/A",
      reference: "",
      amount: 0,
      discount: 0,
    },
  ],
}

const initialState = {
  currency: "INR",
  schedule: "",
  scheduleStartDate: "",
  feeComponentArray: [],
}

const AddFeeComponent = ({ isOpen, close, add }) => {
  const [feeHeads, setFeeHeads] = useState([])
  const [inputValue, setInputValue] = useState("")

  const [searching, setSearching] = useState(false)

  const fetchFeeHeads = (value) => {
    searchFeeHeads(value)
      .then((res) =>
        setFeeHeads(res.data.map((r) => ({ ...r, label: r.name })))
      )
      .catch((err) => console.log(err))
      .finally(() => setSearching(false))
  }

  const [feeComp, setFeeComp] = useState(initialState)

  const handleFeeCompChange = (ev) => {
    const { name, value } = ev.target

    if (name === "schedule") {
      setFeeComp({
        ...feeComp,
        [name]: value,
        feeComponentArray: scheduleMap[value],
      })
    } else {
      setFeeComp({
        ...feeComp,
        [name]: value,
      })
    }
  }

  const handleFeeCompDataChange = (ev, i) => {
    const { name, value } = ev.target
    setFeeComp({
      ...feeComp,
      feeComponentArray: [
        ...feeComp.feeComponentArray.slice(0, i),
        {
          ...feeComp.feeComponentArray[i],
          [name]: value,
        },
        ...feeComp.feeComponentArray.slice(i + 1),
      ],
    })
  }

  const addComp = () => {
    const externals = {}
    if (!feeComp?.feeHeadId) externals["feeHead"] = inputValue
    add({ ...feeComp, ...externals })
    setFeeComp(initialState)
    close()
  }

  return (
    <Modal
      title="Add Fee Component"
      isOpen={isOpen}
      close={close}
      action={addComp}
      disabled={!feeComp.schedule}
    >
      <Stack spacing={2}>
        <Stack direction={"row"} spacing={2} alignItems="center">
          <FormItem label="Fee Head">
            <Autocomplete
              loading={searching}
              freeSolo
              value={feeComp.feeHeadId}
              onChange={(_, newValue) => {
                setFeeComp({
                  ...feeComp,
                  feeHeadId: newValue?.id,
                })
              }}
              inputValue={inputValue}
              onInputChange={(_, newInputValue) => {
                setInputValue(newInputValue)
                fetchFeeHeads(newInputValue)
              }}
              getOptionLabel={(option) => option.label}
              options={feeHeads}
              renderInput={(params) => <TextField {...params} />}
            />
          </FormItem>
          <FormItem label="Schedule">
            <Select
              name="schedule"
              value={feeComp.schedule || ""}
              onChange={handleFeeCompChange}
            >
              {schedules.map((s) => (
                <MenuItem value={s}>{s}</MenuItem>
              ))}
            </Select>
          </FormItem>
        </Stack>
        <Grid spacing={1} container>
          {!!feeComp.feeComponentArray.length && (
            <Grid
              container
              item
              xs={12}
              spacing={2}
              sx={{ fontWeight: 600 }}
              mb={1}
            >
              <Grid item xs={6}>
                Particulars
              </Grid>
              <Grid item xs={3}>
                Due
              </Grid>
              <Grid item xs={3}>
                Discount
              </Grid>
            </Grid>
          )}

          {feeComp.feeComponentArray.map((d, i) => (
            <Grid container item xs={12} spacing={2}>
              <Grid item xs={6}>
                {d.name}
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  type="number"
                  name="amount"
                  value={d.amount}
                  onChange={(e) => handleFeeCompDataChange(e, i)}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  size="small"
                  type="number"
                  name="discount"
                  value={d.discount}
                  onChange={(e) => handleFeeCompDataChange(e, i)}
                />
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Modal>
  )
}

export default AddFeeComponent
